export const base64StringCleanUp = async (
  base64String: string
): Promise<string> => {
  const base64StringCleanUp = base64String.replace(
    /^data:image\/\w+;base64,/,
    ''
  );
  return base64StringCleanUp.trim();
};
